export const setLangUz = () => {
    return { type: "uz" };
};
export const setLangRu = () => {
    return { type: "ru" };
};
export const setLangEn = () => {
    return { type: "en" };
};
